import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { ToggleDefaultIcon, ToggleHierarchyIcon } from "../icons";

import { LIST_VIEW_TYPE } from '../../constants';

const StatusToggleActiveView = (props) => {
    const { viewMode: viewMode_ } = props;
    const viewMode = viewMode_.toUpperCase();
    return (
        <span className={clsx("btn-dropdown-status")}>
            {(viewMode?.toLowerCase() === LIST_VIEW_TYPE.LIST && <ToggleDefaultIcon />) ||
                (viewMode?.toLowerCase() === LIST_VIEW_TYPE.HIERARCHY && <ToggleHierarchyIcon />)}
        </span>
    );
};
StatusToggleActiveView.propType = {
    viewMode: PropTypes.oneOf([LIST_VIEW_TYPE.LIST, LIST_VIEW_TYPE.HIERARCHY]),
};
StatusToggleActiveView.defaultProps = {
    viewMode: LIST_VIEW_TYPE.LIST,
}

export default StatusToggleActiveView;
